module.exports = __webpack_public_path__ + "static/img/index_02_01.63a316a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_02_01.jpg
// module id = +X6F
// module chunks = 1